define('setup/reserve',['require','cookie-handler'],function (require) {
    var cookies = require('cookie-handler');

    return function () {
        var self = this;

        self.canActivate = function () {
            // set the cookie to force thr workflow to finish on my-meetings page
            cookies.setSession('reserve', true);

            return {redirect: 'setup'};
        };
    };
});

